

































import {Component, Prop, Vue} from 'vue-property-decorator';
import JdiContent from "@/components/JdiContent.vue"
import JdiPreview from "@/components/JdiPreview.vue"
import JdsTimelineItem from "@/design-system/components/Timeline/JdsTimelineItem.vue"
import JdiDocs from "@/components/JdiDocs.vue"
import JdsTimeline from "@/design-system/components/Timeline/JdsTimeline.vue"
@Component({
    components: {JdsTimeline, JdiDocs, JdsTimelineItem, JdiPreview, JdiContent}
})
export default class Timeline extends Vue {
}
